import React from 'react';

const Options = ({ className = '', stroke = '#616874', ...props }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.08325 9.99967C2.08325 6.26772 2.08325 4.40175 3.24262 3.24237C4.40199 2.08301 6.26797 2.08301 9.99992 2.08301C13.7318 2.08301 15.5978 2.08301 16.7573 3.24237C17.9166 4.40175 17.9166 6.26772 17.9166 9.99967C17.9166 13.7316 17.9166 15.5976 16.7573 16.757C15.5978 17.9163 13.7318 17.9163 9.99992 17.9163C6.26797 17.9163 4.40199 17.9163 3.24262 16.757C2.08325 15.5976 2.08325 13.7316 2.08325 9.99967Z"
      stroke={stroke}
      strokeWidth="1.67"
      strokeLinejoin="round"
    />
    <path
      d="M7.08325 8.33301C6.39289 8.33301 5.83325 7.77337 5.83325 7.08301C5.83325 6.39265 6.39289 5.83301 7.08325 5.83301C7.77361 5.83301 8.33325 6.39265 8.33325 7.08301C8.33325 7.77337 7.77361 8.33301 7.08325 8.33301Z"
      stroke={stroke}
      strokeWidth="1.67"
    />
    <path
      d="M12.9167 14.166C13.6071 14.166 14.1667 13.6063 14.1667 12.916C14.1667 12.2257 13.6071 11.666 12.9167 11.666C12.2264 11.666 11.6667 12.2257 11.6667 12.916C11.6667 13.6063 12.2264 14.166 12.9167 14.166Z"
      stroke={stroke}
      strokeWidth="1.67"
    />
    <path
      d="M8.33325 7.08301H14.1666"
      stroke={stroke}
      strokeWidth="1.67"
      strokeLinecap="round"
    />
    <path
      d="M11.6666 12.916H5.83325"
      stroke={stroke}
      strokeWidth="1.67"
      strokeLinecap="round"
    />
  </svg>
);

export default Options;
